import { Link, useLocation } from "react-router-dom"
import { classNames } from "shared/lib/classNames/classNames"
import cls from './Header.module.scss'

interface ItemHeaderProps {
    to: string,
    name: string
}

export const ItemHeader = (props: ItemHeaderProps) => {
    const { to, name } = props

    const location = useLocation()

    return (
        <Link to={to} className={classNames(cls.item, {}, [to === location.pathname ? cls.active : undefined])}>{name}</Link>
    )
}